import React, { useContext } from 'react'
import { ParagraphInfo } from 'pyrexx-react-library'

import UserContext from '../../helper/userContext'
import graphql from 'babel-plugin-relay/macro'
import QueryRendererContainer from '../../components/QueryRendererContainer/QueryRendererContainer'
import environment from '../../environments/pom/Environment'
import PageContainer from '../../components/PageContainer'

const query = graphql`
  query PrivacyQuery($lang: Language!) {
    DSS: Document(type: DSS, lang: $lang) {
      id
      coId
      date
      title
      paragraphs {
        number
        name
        sections {
          name
          number
          text
        }
      }
    }
  }
`

const Privacy = (props) => {
  const { user, currentLanguage } = useContext(UserContext)

  const variables = {
    lang: currentLanguage,
  }

  return (
    <QueryRendererContainer
      environment={environment(user.accessToken)}
      query={query}
      variables={variables}
      render={(data) => {
        return (
          <PageContainer noGutter>
            <ParagraphInfo content={data} />
          </PageContainer>
        )
      }}
    />
  )
}
export default Privacy
